import React from 'react';
import { KalenderBegivenhed } from '../../types';
import { formaterDato } from '../../utils/dateUtils';
import Badge from '../shared/Badge';
import DannebrogFlag from '../shared/DannebrogFlag';
import styles from './UpcomingCard.module.scss';

interface UpcomingCardProps {
  begivenhed: KalenderBegivenhed;
}

function TypeIcon({ type }: { type: string }) {
  if (type === 'officiel') return <DannebrogFlag size={24} />;
  if (type === 'foedselsdag') return <>🎂</>;
  return <>📅</>;
}

function formatDageVaek(dageVaek: number): string {
  if (dageVaek === 0) return 'I dag! 🎉';
  if (dageVaek === 1) return 'I morgen';
  return `Om ${dageVaek} dage`;
}

const UpcomingCard: React.FC<UpcomingCardProps> = ({ begivenhed }) => {
  const isToday = begivenhed.dageVaek === 0;

  return (
    <div className={`${styles.card} ${styles[`card-${begivenhed.type}`]} ${isToday ? styles.today : ''}`}>
      <div className={styles.emoji} aria-hidden="true">
        <TypeIcon type={begivenhed.type} />
      </div>
      <div className={styles.content}>
        <div className={styles.top}>
          <span className={styles.titel}>{begivenhed.titel}</span>
          <Badge type={begivenhed.type} />
        </div>
        <div className={styles.bottom}>
          <span className={styles.dato}>{formaterDato(begivenhed.dato)}</span>
          <span className={`${styles.dageVaek} ${isToday ? styles.today : ''}`}>
            {formatDageVaek(begivenhed.dageVaek)}
          </span>
        </div>
        {begivenhed.beskrivelse && (
          <p className={styles.beskrivelse}>{begivenhed.beskrivelse}</p>
        )}
        {(begivenhed.vej || begivenhed.vejnummer) && (
          <p className={styles.adresse}>
            📍 {[begivenhed.vej, begivenhed.vejnummer].filter(Boolean).join(' ')}
          </p>
        )}
      </div>
    </div>
  );
};

export default UpcomingCard;
